module.exports = __webpack_public_path__ + "static/media/box-shell.57731aa5.svg";